<template>
  <div class="dash-preview">
    <div class="container">
      <b-modal id="modal-checkin-privacy"
               modal-class="modal-mobile-fullscreen modal-face-checkin"
               centered
               size="md" no-close-on-backdrop
      >
        <template #modal-header>
          <h1 class="modal-title modal-title--small">{{ $t('modal_pre_checkin_face_recognition.photo_step.title2') }}</h1>
        </template>
        <div class="video-container">
          <div class="preview" style="margin-top: 40px">
            <img src="../../assets/preview/face-graphic.png" class="img-preview img-fluid d-block mx-auto"
                 style="max-width: 200px;min-height: auto">
          </div>
        </div>
        <div class="text-center d-flex align-items-center justify-content-center mt-3">
          <div class="text-left text-info-selfie w-100">
            <template v-if="data">
              <!-- Se ci sono checkbox, ordine: share_policy -> privacy -> share_policy2 -> share_policy3 -->
              <template v-if="data.show_share_policy_checkbox || data.show_privacy_checkbox">
                <template v-if="data.show_share_policy_checkbox">
                  <b-form-checkbox v-model="consentShareDataWithOwner"
                                   name="consent_share_data_with_owner"
                                   :value="true"
                                   :unchecked-value="false">
                    <span class="face-privacy" v-html="sharePolicyText"></span>
                  </b-form-checkbox>
                </template>
                <template v-if="data.show_privacy_checkbox">
                  <b-form-checkbox v-model="acceptPrivacySelfie"
                                   name="consent_privacy_and_terms"
                                   :value="true"
                                   :unchecked-value="false">
                    <span class="face-privacy" v-html="privacyPolicyText"></span>
                    <div class="privacy-blur"></div>
                  </b-form-checkbox>
                </template>
                <!-- Share Policy 2 -->
                <template v-if="data.share_policy2_type && data.share_policy2_type !== 'none'">
                  <b-form-checkbox v-model="acceptSharePolicy2"
                                   name="consent_share_policy2"
                                   :value="true"
                                   :unchecked-value="false">
                    <span class="face-privacy" v-html="sharePolicy2Text"></span>
                    <div class="privacy-blur"></div>
                  </b-form-checkbox>
                </template>
                <!-- Share Policy 3 -->
                <template v-if="data.share_policy3_type && data.share_policy3_type !== 'none'">
                  <b-form-checkbox v-model="acceptSharePolicy3"
                                   name="consent_share_policy3"
                                   :value="true"
                                   :unchecked-value="false">
                    <span class="face-privacy" v-html="sharePolicy3Text"></span>
                    <div class="privacy-blur"></div>
                  </b-form-checkbox>
                </template>
              </template>
              
              <!-- Se NON ci sono checkbox, ordine: share_policy2 -> share_policy3 -> testo -->
              <template v-else>
                <!-- Share Policy 2 -->
                <template v-if="data.share_policy2_type && data.share_policy2_type !== 'none'">
                  <b-form-checkbox v-model="acceptSharePolicy2"
                                   name="consent_share_policy2"
                                   :value="true"
                                   :unchecked-value="false">
                    <span class="face-privacy" v-html="sharePolicy2Text"></span>
                    <div class="privacy-blur"></div>
                  </b-form-checkbox>
                </template>
                <!-- Share Policy 3 -->
                <template v-if="data.share_policy3_type && data.share_policy3_type !== 'none'">
                  <b-form-checkbox v-model="acceptSharePolicy3"
                                   name="consent_share_policy3"
                                   :value="true"
                                   :unchecked-value="false">
                    <span class="face-privacy" v-html="sharePolicy3Text"></span>
                    <div class="privacy-blur"></div>
                  </b-form-checkbox>
                </template>
                <!-- Testo senza checkbox -->
                <span v-html="privacyPolicyText"></span>
              </template>
              
              <div class="d-flex w-100 mt-3" v-if="langs.length > 1">
                <select v-model="lang" class="form-control form-control-sm">
                  <option v-for="lang in langs" :value="lang" :key="lang">{{ lang }}</option>
                </select>
              </div>
            </template>
          </div>
        </div>

        <template v-slot:modal-footer>
          <div class="row w-100 justify-content-center">
            <div class="col-sm-6 order-sm-1 mb-2 mb-sm-0">
              <button-with-spinner class="btn btn-primary btn-block"
                                   :disabled="confirmDisabled">
                {{ $t('modal_pre_checkin_face_recognition.btn_confirm') }}
              </button-with-spinner>
            </div>
            <div class="col-sm-6 order-sm-0">
              <b-button variant="light" block>
                {{ $t('modal_pre_checkin_face_recognition.photo_step.retake_photo') }}
              </b-button>
            </div>
          </div>


        </template>
      </b-modal>
    </div>
  </div>
</template>


<script>
import ButtonWithSpinner from "@/components/ButtonWithSpinner.vue";

export default {
  name: 'PreviewPrivacy',
  components: {ButtonWithSpinner},
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  computed: {
    confirmDisabled() {
      if (this.data.show_privacy_checkbox && !this.acceptPrivacySelfie) return true
      if (this.data.share_policy2_type === 'mandatory' && !this.acceptSharePolicy2) return true
      if (this.data.share_policy3_type === 'mandatory' && !this.acceptSharePolicy3) return true
      return false
    },
    privacyPolicyText() {
      if (this.data.privacy_policy_type === 'pica') {
        return this.$t('modal_pre_checkin_face_recognition.photo_step.info')
      }
      return this.data.privacy_policy_text ? this.data.privacy_policy_text[this.lang] : ''
    },
    sharePolicyText() {
      return this.data.share_policy_text[this.lang]
    },
    sharePolicy2Text() {
      return this.data.share_policy2_text ? this.data.share_policy2_text[this.lang] : ''
    },
    sharePolicy3Text() {
      return this.data.share_policy3_text ? this.data.share_policy3_text[this.lang] : ''
    },
    langs() {
      const allTexts = [
        this.data.privacy_policy_text,
        this.data.share_policy_text,
        this.data.share_policy2_text,
        this.data.share_policy3_text
      ].filter(text => text && typeof text === 'object');
      
      if (allTexts.length === 0) return [];
      
      // Ottieni tutte le lingue disponibili
      const allLangs = new Set();
      allTexts.forEach(text => {
        Object.keys(text).forEach(lang => allLangs.add(lang));
      });
      
      // Filtra solo le lingue che hanno almeno un testo valorizzato (min 4 caratteri)
      return Array.from(allLangs).filter(lang => {
        return allTexts.some(text => text[lang] && text[lang].trim().length >= 4);
      });
    }
  },
  data() {
    return {
      acceptPrivacySelfie: false,
      acceptSharePolicy2: false,
      acceptSharePolicy3: false,
      consentShareDataWithOwner: false,
      lang: this.$i18n.locale
    }
  },
  async mounted() {
    await this.$nextTick()
    this.$bvModal.show('modal-checkin-privacy')
  },
  methods: {}
}
</script>
